import { IEnvironment } from "./environment";

export const stagingEnv: IEnvironment = {
  env: "staging",
  api: {
    protocol: "http",
    host: "aurora-api.apps.ocp11.topnet.rs",
  },
  oidc: {
    clientId: "237923339606228995@braco-test",
    issuerEndpoint: "https://zitadel.puvaron.com",
    loginCallbackUrl: "http://localhost:3000/code",
    authorizationEndpoint: "https://zitadel.puvaron.com/oauth/v2/authorize",
    scope: "openid profile email urn:zitadel:iam:user:metadata",
    keyListEndpoint: "https://zitadel.puvaron.com/oauth/v2/keys",
    userInfoEndpoint: "https://zitadel.puvaron.com/oidc/v1/userinfo",
    roleFieldName: "",
    endSessionEndpoint: "https://zitadel.puvaron.com/oidc/v1/end_session",
  },
  modulesEnabled: {
    archive: false,
    digitalSignature: true,
    qualifiedDigitalSignature: true,
    tasks: true,
    sefProvider: true,
    emailListenerProvider: true,
    networkShareProvider: true,
    ocr: false,
  },
  documentTableColumns: {
    userName: true,
    description: true,
    creationDate: true,
    archiveDate: false,
    documentType: true,
    documentStatus: true,
    tags: true,
  },
};
